export default () => {
  const videoWrapper = $('#video-trigger-wrapper');
  const video = $('#yt-video');
  const videoForeground = $('#yt-video-foreground');
  const readMoreButton = $('#board-heading-read-more');
  const aboutBoardText = $('.about-board__board-text');
  const moduleList = $('#advanced-module-list');
  const moduleListWrapper = $('.board-course-list__modules');
  const blogPostWrapper = $('.board-course-list__sidebar-container');

  videoWrapper.on('click', function () {
    video.attr('src', video.data('src') + '?autoplay=1');
    videoForeground.hide();
  });

  readMoreButton.on('click', function () {
    aboutBoardText.toggleClass('expanded-text');
    $(this).text(aboutBoardText.hasClass('expanded-text') ? $(this).data('read-less') : $(this).data('read-more'));
  });

  const adjustStickyElements = () => {
    if (moduleListWrapper.length && blogPostWrapper.length) {
      let moduleListWrapperPosition = moduleListWrapper.position().top + moduleListWrapper.outerHeight(true);
      let blogPostsPosition = blogPostWrapper.position().top + blogPostWrapper.outerHeight(true);

      moduleList.toggleClass('sticky', moduleListWrapperPosition < blogPostsPosition);
      blogPostWrapper.toggleClass('sticky', moduleListWrapperPosition >= blogPostsPosition);
    }
  };

  if (moduleListWrapper.length && blogPostWrapper.length) {
    adjustStickyElements();
  }
};
